import * as React from 'react';

import { ORDER_STATUS } from '@klareospace/pharos-lib-types';
import type { OrderStatus } from '@klareospace/pharos-lib-types';

import { StackedCell } from '../data-table/stacked-cell';
import { StatusBadge } from '../status-badge/status-badge';
import { STATUS_BADGE_COLORS } from '../status-badge/status-badge-colors';

// ─── Constants ────────────────────────────────────────────────────────────────

export const ORDER_STATUS_BADGE_COLORS: Record<OrderStatus, string> = {
  [ORDER_STATUS.ANOMALY]: STATUS_BADGE_COLORS.danger,
  [ORDER_STATUS.ARRIVED_AT_DELIVERY]: STATUS_BADGE_COLORS.info,
  [ORDER_STATUS.ARRIVED_AT_PICKUP]: STATUS_BADGE_COLORS.info,
  [ORDER_STATUS.CANCELLED]: STATUS_BADGE_COLORS.danger,
  [ORDER_STATUS.CARRIER_ACCEPTED]: STATUS_BADGE_COLORS.info,
  [ORDER_STATUS.CARRIER_ASSIGNED]: STATUS_BADGE_COLORS.neutral,
  [ORDER_STATUS.CARRIER_REJECTED]: STATUS_BADGE_COLORS.danger,
  [ORDER_STATUS.COMPLETED]: STATUS_BADGE_COLORS.success,
  [ORDER_STATUS.DRAFT]: STATUS_BADGE_COLORS.neutral,
  [ORDER_STATUS.DRIVER_ACCEPTED]: STATUS_BADGE_COLORS.info,
  [ORDER_STATUS.DRIVER_ASSIGNED]: STATUS_BADGE_COLORS.neutral,
  [ORDER_STATUS.DRIVING_TO_DELIVERY]: STATUS_BADGE_COLORS.info,
  [ORDER_STATUS.DRIVING_TO_PICKUP]: STATUS_BADGE_COLORS.info,
  [ORDER_STATUS.FAILED]: STATUS_BADGE_COLORS.danger,
  [ORDER_STATUS.IN_TRANSIT]: STATUS_BADGE_COLORS.info,
  [ORDER_STATUS.NEW]: STATUS_BADGE_COLORS.neutral,
  [ORDER_STATUS.PENDING]: STATUS_BADGE_COLORS.neutral,
  [ORDER_STATUS.PICKUP_COMPLETED]: STATUS_BADGE_COLORS.info,
  [ORDER_STATUS.WAITING_FOR_PICKUP]: STATUS_BADGE_COLORS.info,
};

// ─── Types ────────────────────────────────────────────────────────────────────

export interface OrderStatusBadgeProps {
  /** The translated label to show inside the badge */
  label: string;
  /** Optional translated reason text shown as small muted text below the badge */
  reasonLabel?: string;
  /** The order status value used to look up the badge colour */
  status: OrderStatus;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function OrderStatusBadge({ label, reasonLabel, status }: OrderStatusBadgeProps): React.JSX.Element {
  return (
    <StackedCell
      primary={<StatusBadge label={label} status={status} styles={ORDER_STATUS_BADGE_COLORS} />}
      secondary={reasonLabel}
      secondaryClassName="text-[11px] text-destructive/80 line-clamp-2 leading-tight"
    />
  );
}
